import { imageUrl } from '@/vm/Shared/imageUrl';
import { IconWrapper, IconImage, IconContent } from './Icon.styles';

type OwnProps = {
  imageFilename: string;
  labelOne: string;
  labelTwo?: string;
  number: string;
  position: string;
};

export default function Icon({
  imageFilename,
  labelOne,
  labelTwo,
  number,
  position
}: OwnProps) {
  return (
    <IconWrapper className={position}>
      <IconContent>
        <h3>{number}</h3>
        <IconImage>
          <img src={imageUrl(imageFilename)} />
        </IconImage>
      </IconContent>
      <h2>
        <div>{labelOne}</div>
        <div>{labelTwo}</div>
      </h2>
    </IconWrapper>
  );
}
